export function tenDaysAccordion() {
	const section = document.querySelector('.ten-days');
	if (!section) return;

	const items = section.querySelectorAll('.ten-days__item');
	if (!items.length) return;

	items.forEach((item) => {
		const header = item.querySelector('.ten-days__item-header');
		if (!header) return;

		header.addEventListener('click', () => {
			const isActive = item.classList.contains('active');

			// Close all items
			items.forEach((otherItem) => {
				otherItem.classList.remove('active');
			});

			// Open clicked item if it wasn't active
			if (!isActive) {
				item.classList.add('active');
			}
		});
	});
}
